import React, {Component} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'

import Manager from './Manager'
import Builder from './Builder'
import Backtest from './Backtest'
import BacktestDebug from './Backtest/Debug'
import Screener from './Screener'
import ScreenerBuilder from './Screener/Builder'
import PaperTrading from './PaperTrading'
import PaperTradingDebug from './PaperTrading/Debug'
import Analysis from './Analysis'
import Profile from './Profile'
import Videos from './Videos'
import NotFound from './NotFound'
import ConfirmEmail from './ConfirmEmail'
import Checkout from './Checkout'
import Upgrade from './Upgrade'
import {TermsAndConditions, PrivacyPolicy, Contact} from './Public'

import Sentry from './Sentry'

class Routes extends Component {
  render() {
    const {is_subscribed, is_email_verified, is_staff} = this.props
    return(
      <Switch>
        <Redirect exact from='/' to='/manager'/>
        <Redirect exact from='/login' to='/manager'/>
        <Redirect exact from='/signup-complete' to='/manager'/>
        <Redirect exact from='/password-recovery' to='/manager'/>

        <Route path='/profile' component={Profile}/>
        <Route path='/checkout' exact component={Checkout}/>
        <Route path='/confirm-email' component={ConfirmEmail}/>

        {(is_subscribed === false && !is_staff) &&
          <Redirect to='/checkout'/>
        }

        {(is_email_verified === false && !is_staff) &&
          <Redirect to='/confirm-email'/>
        }

        <Route path='/upgrade' exact component={Upgrade}/>
        <Route path='/manager' exact component={Manager}/>
        <Route path='/manager/paper-trading/:paperID/debug' component={PaperTradingDebug}/>
        <Route path='/manager/paper-trading/:paperID' component={PaperTrading}/>
        <Route path='/builder' exact component={Builder}/>
        <Route path='/builder/edit/:algoID' component={Builder}/>
        <Route path='/backtest/algo/:backtestID/debug' component={BacktestDebug}/>
        <Route path='/backtest/algo/:backtestID' component={Backtest}/>
        <Route path='/stock-filters' exact component={Screener}/>
        <Route path='/stock-filters/builder' exact component={ScreenerBuilder}/>
        <Route path='/stock-filters/builder/:screenerID' component={ScreenerBuilder}/>
        <Route path='/videos/:video' component={Videos}/>
        <Route path='/analysis' component={Analysis}/>

        <Route path='/terms-and-conditions' exact component={TermsAndConditions}/>
        <Route path='/privacy-policy' exact component={PrivacyPolicy}/>
        <Route path='/contact' exact component={Contact}/>
        <Route path='/sentry' exact component={Sentry}/>
        <Route component={NotFound}/>
      </Switch>
    )
  }
}

export default Routes
